import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllMOMTrades = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.MOMTrade}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getMOMTradeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.MOMTrade}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertMOMTrade = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.MOMTrade, input);
  return data;
};

const updateMOMTrade = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.MOMTrade, input);
  return data;
};

const deleteMOMTrade = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.MOMTrade}?CompanyCode=${companyCode}&code=${code}`
  );
  return data;
};

export const useGetMOMTradesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.MOMTrade],
    queryFn: () => getAllMOMTrades(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetMOMTradeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.MOMTrade],
    queryFn: () => getMOMTradeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertMOMTradeMutation = () => {
  return useMutation({
    mutationFn: insertMOMTrade,
  });
};

export const useUpdateMOMTradeMutation = () => {
  return useMutation({
    mutationFn: updateMOMTrade,
  });
};

export const useDeleteMOMTradeMutation = () => {
  return useMutation({
    mutationFn: deleteMOMTrade,
  });
};
